import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=7636df7a&scoped=true&"
import script from "./NavigationTabs.vue?vue&type=script&lang=ts&"
export * from "./NavigationTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636df7a",
  null
  
)

export default component.exports